import { handleValidationChange } from "../CommonValidation";

export const validateAddPO = (data, items, setIsError) => {
    var isValid = true;
    var isValidSupplier = true;
    var isValidPurchaseDate = true;
    var isValidDeliveryDate = true;
    var isValidRequisitioner = true;
    var isValidDeliveryAddress = true;
    var isValidItems = true;
    var isValidBranchId = true

    if (data.supplier_id === "" && data.vendor_id === "") {
        handleValidationChange("supplierName", true, setIsError);
        isValidSupplier = false;
    } else {
        handleValidationChange("supplierName", false, setIsError);
        isValidSupplier = true;
    }

    if (
        data.purchase_date === "" ||
        data.purchase_date === undefined ||
        data.purchase_date === "Invalid Date"
    ) {
        handleValidationChange("purchaseDate", true, setIsError);
        isValidPurchaseDate = false;
    } else {
        handleValidationChange("purchaseDate", false, setIsError);
        isValidPurchaseDate = true;
    }

    if (
        data.delivery_date === "" ||
        data.delivery_date === undefined ||
        data.delivery_date === "Invalid Date"
    ) {
        handleValidationChange("deliveryDate", true, setIsError);
        isValidDeliveryDate = false;
    } else {
        handleValidationChange("deliveryDate", false, setIsError);
        isValidDeliveryDate = true;
    }

    if (data.requisitioner === "" || data.requisitioner === undefined) {
        handleValidationChange("requisitioner", true, setIsError);
        isValidRequisitioner = false;
    } else {
        handleValidationChange("requisitioner", false, setIsError);
        isValidRequisitioner = true;
    }

    if(data.branch_id === "" || data.branch_id === undefined) {
        handleValidationChange("branchId", true, setIsError);
        isValidBranchId = false;
    } else {
        handleValidationChange("branchId", false, setIsError);
        isValidBranchId = true;
    }

    if (data.delivery_address === "" || data.delivery_address === undefined) {
        handleValidationChange("deliveryAddress", true, setIsError);
        isValidDeliveryAddress = false;
    } else {
        handleValidationChange("deliveryAddress", false, setIsError);
        isValidDeliveryAddress = true;
    }

    if (items?.length === 0) {
        handleValidationChange("itemsList", true, setIsError);
        isValidItems = false;
    } else {
        handleValidationChange("itemsList", false, setIsError);
        isValidItems = true;
    }

    // items?.map((data) => {
    //     //
    //     if (data.price === "" || data.price === undefined || data.price === 0) {
    //         handleValidationChange("price", true, setIsError);
    //         isValidAmount = false;
    //     } else {
    //         handleValidationChange("price", false, setIsError);
    //         isValidAmount = true;
    //     }
    // });

    isValid =
        isValidSupplier &&
        isValidPurchaseDate &&
        isValidDeliveryDate &&
        isValidRequisitioner &&
        isValidDeliveryAddress &&
        isValidItems &&
        isValidBranchId;

    return isValid;
};


export const validateEditPO = (data, items, setIsError) => {
    var isValid = true;
    var isValidSupplier = true;
    var isValidPurchaseDate = true;
    var isValidDeliveryDate = true;
    var isValidRequisitioner = true;
    var isValidDeliveryAddress = true;
    var isValidAmount = true;
    var isValidQty = true;
    var isValidDescription = true;
    var isValidBranchId = true;

    if (data.supplier_id === "" && data.vendor_id === "") {
        handleValidationChange("supplierName", true, setIsError);
        isValidSupplier = false;
    } else {
        handleValidationChange("supplierName", false, setIsError);
        isValidSupplier = true;
    }

    if (
        data.purchase_date === "" ||
        data.purchase_date === undefined ||
        data.purchase_date === "Invalid Date"
    ) {
        handleValidationChange("purchaseDate", true, setIsError);
        isValidPurchaseDate = false;
    } else {
        handleValidationChange("purchaseDate", false, setIsError);
        isValidPurchaseDate = true;
    }

    if (
        data.delivery_date === "" ||
        data.delivery_date === undefined ||
        data.delivery_date === "Invalid Date"
    ) {
        handleValidationChange("deliveryDate", true, setIsError);
        isValidDeliveryDate = false;
    } else {
        handleValidationChange("deliveryDate", false, setIsError);
        isValidDeliveryDate = true;
    }

    if(data.branch_id === "" || data.branch_id === undefined) {
        handleValidationChange("branchId", true, setIsError);
        isValidBranchId = false;
    } else {
        handleValidationChange("branchId", false, setIsError);
        isValidBranchId = true;
    }


    if (data.requisitioner === "" || data.requisitioner === undefined) {
        handleValidationChange("requisitioner", true, setIsError);
        isValidRequisitioner = false;
    } else {
        handleValidationChange("requisitioner", false, setIsError);
        isValidRequisitioner = true;
    }

    if (data.delivery_address === "" || data.delivery_address === undefined) {
        handleValidationChange("deliveryAddress", true, setIsError);
        isValidDeliveryAddress = false;
    } else {
        handleValidationChange("deliveryAddress", false, setIsError);
        isValidDeliveryAddress = true;
    }

    items?.map((data) => {
        //
        if ((data.description === "" || data.description === undefined || data.description === 0) && 
            (data.item_id === "" || data.item_id === undefined || data.item_id === 0)) {
            handleValidationChange("description", true, setIsError);
            isValidDescription = false;
        } else {
            handleValidationChange("description", false, setIsError);
            isValidDescription = true;
        }
        if (data.price === "" || data.price === undefined || data.price === 0) {
            handleValidationChange("price", true, setIsError);
            isValidAmount = false;
        } else {
            handleValidationChange("price", false, setIsError);
            isValidAmount = true;
        }
        if (data.qty === "" || data.qty === undefined || data.qty === 0) {
            handleValidationChange("qty", true, setIsError);
            isValidQty = false;
        } else {
            handleValidationChange("qty", false, setIsError);
            isValidQty = true;
        }
    });

    isValid =
        isValidSupplier &&
        isValidPurchaseDate &&
        isValidDeliveryDate &&
        isValidRequisitioner &&
        isValidDeliveryAddress &&
        isValidAmount &&
        isValidQty &&
        isValidDescription &&
        isValidBranchId;

    return isValid;
};


export const validatePoPayment = (data, balance, setIsError) => {
    var isValid = true;

    if((data.paid_amount === "" || parseFloat(data.paid_amount) <= 0) && balance === 0) {
        handleValidationChange("paid_amount", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("paid_amount", false, setIsError);
    }

    if(data.payment_type === "") {
        handleValidationChange("payment_type", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("payment_type", false, setIsError);
    }

    if(data.payment_type === "check" && data.cheque_number === "") {
        handleValidationChange("cheque_number", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("cheque_number", false, setIsError);
    }

    if(data.payment_type === "check" && (data.cheque_date === "" || data.cheque_date === undefined || data.cheque_date === null)) {
        handleValidationChange("cheque_date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("cheque_date", false, setIsError);
    }

    if((data.payment_type === "check" || data.payment_type === "bank") && (data.to_bank_name === "" || data.to_bank_name === undefined || data.to_bank_name === null)) {
        handleValidationChange("to_bank_name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("to_bank_name", false, setIsError);
    }

    if(data.payment_type === "others" && (data.transaction_no === "" || data.transaction_no === undefined)) {
        handleValidationChange("transaction_no", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("transaction_no", false, setIsError);
    }

    if(data.payment_date === "") {
        handleValidationChange("payment_date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("payment_date", false, setIsError);
    }

    if(data.payment_type === "bank" && (data.reference_number === "" || data.reference_number === undefined || data.reference_number === null)) {
        handleValidationChange("reference_number", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("reference_number", false, setIsError);
    }

    if(data.payment_type === "bank" && (data.to_account_name === "" || data.to_account_name === undefined || data.to_account_name === null)) {
        handleValidationChange("to_account_name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("to_account_name", false, setIsError);
    }

    if(data.payment_type === "bank" && (data.to_account_no === "" || data.to_account_no === undefined || data.to_account_no === null)) {
        handleValidationChange("to_account_no", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("to_account_no", false, setIsError);
    }

    if(data.payment_type === "bank" && (data.from_bank_id === "" || data.from_bank_id === undefined || data.from_bank_id === null)) {
        handleValidationChange("from_bank_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("from_bank_id", false, setIsError);
    }

    if(data.payment_type === "bank" && (data.from_account_name === "" || data.from_account_name === undefined || data.from_account_name === null)) {
        handleValidationChange("from_account_name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("from_account_name", false, setIsError);
    }

    if(data.payment_type === "bank" && (data.from_account_no === "" || data.from_account_no === undefined || data.from_account_no === null)) {
        handleValidationChange("from_account_no", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("from_account_no", false, setIsError);
    }

    return isValid
  
}